"use strict";

module.exports = Array.isArray.bind(Array);